import * as XLSX from 'xlsx';
import { FlagHistoryItem } from '../../services/edit-users/edit-users.service';

const flagLabel = (flagCode: number): string => {
    if (flagCode === 1) return 'Red';
    if (flagCode === 2) return 'Blue';
    return 'Neutral';
};

// flagCache now stores FlagHistoryItem[] per customer (newest first)
export const AccountReceivableExport = (
    data: any[],
    flagCache: Record<number, FlagHistoryItem[] | FlagHistoryItem | null>
) => {
    const headers = [
        'Invoice #',
        'Invoice Date',
        'Invoice By',
        'Ageing',
        'Gross Amount (₹)',
        'Reward Amount (₹)',
        'Final Amount (₹)',
        'Customer Name',
        'Customer No#',
        'Last Sent Date',
        'Flag Color',
        'Flag Created By',
        'Flag Latest Updated By',
    ];

    const formatDate = (value: string) => {
        if (!value) return '';
        const d = new Date(value);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleDateString('en-gb', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const rows = data.map((row) => {
        const cached = flagCache[row.customerId];

        // Support both array (new) and single-record (old) shape
        const history: FlagHistoryItem[] =
            Array.isArray(cached) ? cached :
                cached != null ? [cached as FlagHistoryItem] : [];

        const flagCode = history.length > 0 ? (history[0]?.flagCode ?? 0) : 0;

        // Newest = history[0], oldest/creator = history[last]
        const latestRecord = history.length > 0 ? history[0] : null;
        const creatorRecord = history.length > 0 ? history[history.length - 1] : null;

        const createdBy = creatorRecord?.updatedByName ?? '';
        // Only show updatedBy if there was an actual update (more than one record, or actionType = 'U')
        const updatedBy =
            latestRecord && creatorRecord && latestRecord !== creatorRecord
                ? (latestRecord.updatedByName ?? '')
                : '';

        return [
            row.invoiceNo ?? '',
            formatDate(row.invoiceDate),
            row.invoiceBy ?? '',
            row.ageDate ?? '',
            row.grossAmount != null ? Math.round(row.grossAmount) : '',
            row.rewardAmount != null ? Math.round(row.rewardAmount) : '',
            row.finalAmount != null ? Math.round(row.finalAmount) : '',
            row.customerName ?? '',
            row.primaryContactNo ?? '',
            formatDate(row.lastLinkDate),
            flagLabel(flagCode),
            createdBy,
            updatedBy,
        ];
    });

    const aoaData = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(aoaData);

    // Bold header row
    headers.forEach((_, idx) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: idx });
        if (ws[cellRef]) {
            ws[cellRef].s = { font: { bold: true } };
        }
    });

    // Column widths
    ws['!cols'] = [
        { wch: 12 }, // Invoice #
        { wch: 14 }, // Invoice Date
        { wch: 16 }, // Invoice By
        { wch: 10 }, // Ageing
        { wch: 18 }, // Gross Amount
        { wch: 22 }, // Customer Name
        { wch: 14 }, // Customer No#
        { wch: 14 }, // Last Sent Date
        { wch: 12 }, // Flag Color
        { wch: 20 }, // Flag Created By
        { wch: 20 }, // Flag Updated By
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Account Receivable');

    const now = new Date();
    const fileName = `Account_Receivable_${now.toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(wb, fileName);
};